<dx-box width="100%" height="100%" direction="col">
    <dxi-item baseSize="auto">
        <div *dxTemplate>
            <fieldset class="field-set dx-theme-border-color">
                <legend class="legend-title">AP Invoice Line Items</legend>
            </fieldset>
        </div>
    </dxi-item>
    <dxi-item [ratio]="1">
        <div *dxTemplate class="grid-container dx-theme-border-color">
            <dx-data-grid
                #lineItemGrid
                width="100%"
                height="100%"
                keyExpr="apBillItemId"
                [repaintChangesOnly]="true"
                [allowColumnReordering]="true"
                [allowColumnResizing]="true"
                [showBorders]="true"
                [showColumnLines]="true"
                [showRowLines]="true"
                [wordWrapEnabled]="true"
                [columnWidth]="100"
                [dataSource]="lineItems"
            >
                <dxi-column dataType="number" caption="Item Id" dataField="apBillItemId" [width]="70"></dxi-column>
                <dxi-column
                    dataType="string"
                    dataField="glAccountNumber"
                    caption="Account Number"
                    [width]="200"
                ></dxi-column>
                <ng-container *ngIf="entityUsesSubCategory">
                    <dxi-column
                        dataField="subCategory"
                        dataType="string"
                        caption="Sub Category"
                        [width]="120"
                    ></dxi-column>
                </ng-container>
                <ng-container *ngIf="showTargetCommunity">
                    <dxi-column
                        dataField="targetCommunity"
                        dataType="string"
                        caption="Target Community"
                        [width]="120"
                    ></dxi-column>
                </ng-container>

                <dxi-column
                    dataType="number"
                    dataField="itemAmount"
                    caption="Amount"
                    [format]="currencyFormat"
                ></dxi-column>

                <ng-container *ngIf="dimensionSource.length > 0">
                    <ng-container *ngFor="let col of dimensionSource">
                        <dxi-column
                            dataType="string"
                            allowSorting="false"
                            [dataField]="col.dimensionCode"
                            [caption]="col.dimensionTitle"
                            [width]="120"
                        ></dxi-column>
                    </ng-container>
                </ng-container>
                <dxi-column dataType="string" dataField="description" caption="Description"></dxi-column>

                <dxo-summary>
                    <dxi-total-item
                        column="itemAmount"
                        name="itemAmount"
                        summaryType="sum"
                        [customizeText]="customizeLineItemSummary"
                    ></dxi-total-item>
                </dxo-summary>
            </dx-data-grid>
        </div>
    </dxi-item>
</dx-box>
